import React from 'react';

import { searchPatients, editPatientsWhiteList, patientsWhiteList } from '../epics-pharmacies';
import svgs from '../../Common/Svgs';
import { CancelBtn, MainBtn } from '../../Common/form/Elements-export';
import { cloneObject } from '../../Common/Helpers';

import localStorage from '../../Common/LocalStorage';
import LocalizedStrings from 'react-localization';
import { translations } from '../../Common/Translations';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));

const header = [
  { name: strings.name, value: 'name' },
  {},
  { name: strings.email, value: 'email' },
  {},
  { name: strings.insuranceCard, value: 'insuranceCard' },
  {}
];

class PatientsWhiteListModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      patientsWhiteList: [],
      patientsWhiteListCount: 0,
      patientsWhiteListIds: [],

      searchPatientsList: [],
      searchPatientsCount: 0,

      orderBy: 'name',
      orderDirection: 'asc',
      page: 0,
      limit: 10,
      searchBy: 'name',
      searchString: '',

      loadingSpinner: false,
      activeWarning: false
    }
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount = () => {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.getPatientsWhiteList(this.state, true);
  }

  componentDidUpdate(prevProps, prevState) {
    let resetPage = false;
  
    if (this.state.searchString !== prevState.searchString && this.state.searchString === '') {
      resetPage = true;
    }

    if (prevState.searchString === '' && this.state.searchString !== '') {
      resetPage = true;
    }
    
    if (
      this.state.orderBy !== prevState.orderBy ||
      this.state.orderDirection !== prevState.orderDirection ||
      this.state.page !== prevState.page ||
      this.state.limit !== prevState.limit ||
      this.state.searchString !== prevState.searchString
    ) {
      if (this.state.searchString === '') {
        this.getPatientsWhiteList(this.state, resetPage);
      } else {
        this.getPatientsSearchList(this.state, resetPage);
      }
    }
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(e) {
    if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.setState({ ...this.state, searchString: '', searchBy: 'name' });
    }
  }
  
  getPatientsWhiteList = ({ orderBy, orderDirection, page, limit }, resetPage) => {
    this.setState({ ...this.state, loadingSpinner: true });
    
    if (resetPage) page = 0;

    if (orderBy === 'insuranceCard') orderBy = 'primaryCardNumber';

    let data = {
        offset: limit * page,
        limit: limit,
        orderBy: orderBy + '.' + orderDirection
    };
 
    patientsWhiteList(this.props.pharmacyId, data).then(response => {
      response.patients.forEach(patient => {
        patient.checked = true;
      });
      this.setState({
        ...this.state,
        patientsWhiteList: response.patients,
        patientsWhiteListCount: response.count,
        patientsWhiteListIds: response.ids,
        loadingSpinner: false
      });
    })
    .catch((error) => {
      this.setState({
        ...this.state,
        patientsWhiteList: [],
        patientsWhiteListCount: 0,
        patientsWhiteListIds: [],
        loadingSpinner: false
      })
    });
  }

  getPatientsSearchList = ({ orderBy, orderDirection, page, limit, searchBy, searchString }, resetPage) => {
    
    if (searchString.length > 1) {

      this.setState({ ...this.state, loadingSpinner: true });

      if (resetPage) page = 0;

      if (orderBy === 'insuranceCard') orderBy = 'primaryCardNumber';

      let data = {
        offset: limit * page,
        limit: limit,
        orderBy: orderBy + '.' + orderDirection,
        searchBy: searchBy,
        searchString: searchString,
        modal: 'whitelist'
      };

      searchPatients(this.props.pharmacyId, data).then(responce => {
        responce.forEach(patient => {
          patient.checked = false;
        });
        this.setState({ ...this.state, searchPatientsList: responce, loadingSpinner: false });
      }).catch(error => {
        console.log(error);
      });
    }
  }

  update = type => e => {
    this.setState({ ...this.state, [type]: e.target.value });
  }

  updateSearchString = e => {
    let page = this.state.page;
 
    if (e.target.value === '') page = 0;

    this.setState({ ...this.state, searchString: e.target.value, page: page });
  }

  updatePatientsList = (patientsList, index) => e => {
    let newList = cloneObject(this.state[patientsList]);
    newList[index].checked = e.target.checked;
    this.setState({ ...this.state, [patientsList]: newList });
  }

  generateSearchCriteria = searchCriteria => {
    return (
      <div className="align-self-center pr-3">
        <input
          type="radio"
          id={searchCriteria}
          name={searchCriteria}
          value={searchCriteria}
          onChange={this.update('searchBy')}
          checked={this.state.searchBy === searchCriteria}
        />
        <label htmlFor={searchCriteria}>
          {strings[searchCriteria]}
        </label>
      </div>
    )
  }

  changeOrderBy = field => {
    if (this.state.orderBy === field && this.state.orderDirection === 'asc') {
        this.setState({
            orderDirection: 'desc',
            page: 0
        });
    } else {
        this.setState({
            orderBy: field,
            orderDirection: 'asc',
            page: 0
        });
    }
  }

  setPageNumber = pageNumber => {
    this.setState({ ...this.state, page: pageNumber });
  }

  generateTableHead = () => {
    let className = this.state.orderDirection === 'asc' ? ' fa fa-angle-down' : 'fa fa-angle-up';

    return (
      <thead>
        <tr>
          {header.map((value, index) => {
            if (value.name !== undefined) {
              return (
                <th key={index}>
                  {this.state.searchString === '' ? (
                    <div onClick={() => this.changeOrderBy(value.value)}>
                    {value.name}
                    {this.state.orderBy === value.value ? (
                      <i className={className} />
                    ) : (
                      <i className={'qf-invisible ' + className} />
                    )}
                  </div>
                  ) : (
                    <div>{value.name}</div>
                  )}
                </th>
              )
            } else {
              return <th key={index} />
            }
          })}
        </tr>
      </thead>
    )

    
  }

  generateTableBody = listName => {
    let patientsList = this.state[listName] || [];
    
    return (
      <tbody>
        {this.state.loadingSpinner ? (
          <tr>
            <td colSpan={6} className="text-center p-3">
              <i className="fa fa-spinner fa-spin fa-3x" />
            </td>
          </tr>
        ) : (
          patientsList.length === 0 ? (
            <tr>
              <td colSpan={6} className="text-center p-3">
                {strings.no_results_found}
              </td>
            </tr>
          ) : (
            patientsList.map((patient, index) => {
              return (
                <tr key={patient.id}>
                  <td>{patient.name}</td>
                  <td />
                  <td>{patient.email}</td>
                  <td />
                  <td>{patient.primaryCardNumber}</td>
                  <td className="text-right">
                    <input
                      className="qf-custom-checkbuttons relative"
                      type="checkbox"
                      onChange={this.updatePatientsList(listName, index)}
                      checked={patient.checked || false}
                    />
                  </td>
                </tr>
              )
            })
          )
        )}
      </tbody>
    )
  }

  generatePagination = patientsList => {
    let counter = this.state[patientsList + 'Count'],
        list = this.state[patientsList];
 
    if (counter !== undefined && list !== undefined && counter > list.length) {
      let pagesArr = Array.apply(null, { length: Math.ceil(counter / parseInt(this.state.limit, 10)) }).map(
        Number.call,
        Number
      );

      return (
        <div className="row">
          <div className="col qf-mb-30 text-center">
            <nav aria-label="navigation">
              <ul className="pagination justify-content-center">
                <li className={'page-item' + (this.state.page === 0 ? ' disabled' : '')}>
                  <a className="page-link" onClick={() => this.setPageNumber(0)}>
                    {strings.first}
                  </a>
                </li>
                {pagesArr.map(pageNumber => {
                  if (this.state.page - 10 <= pageNumber && this.state.page + 10 >= pageNumber) {
                    return (
                      <li
                        key={pageNumber}
                        className={'page-item' + (this.state.page === pageNumber ? ' active' : '')}
                      >
                        <a className="page-link" onClick={() => this.setPageNumber(pageNumber)}>
                          {pageNumber + 1}
                        </a>
                      </li>
                    );
                  } else {
                    return null;
                  }
                })}
                <li className={'page-item ' + (this.state.page === pagesArr.length - 1 ? 'disabled' : '')}>
                  <a className="page-link" onClick={() => this.setPageNumber(pagesArr.length - 1)}>
                    {strings.last}
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      )
    }
  }

  saveNewWhiteList = type => {
    let newWhiteListIds = cloneObject(this.state.patientsWhiteListIds),
        listName = type === 'add' ? 'searchPatientsList' : 'patientsWhiteList';

    this.state[listName].forEach(patient => {
      
      if (patient.checked === true && !newWhiteListIds.includes(patient.id)) {
        newWhiteListIds.push(patient.id);
      }
      if (patient.checked !== true) {
        let elementIndex = newWhiteListIds.indexOf(patient.id);
        if (elementIndex !== -1) {
          newWhiteListIds.splice(elementIndex, 1);
        }
      }
    });

    editPatientsWhiteList({ids: newWhiteListIds}, this.props.pharmacyId).then(response => {
      this.setState({
        ...this.state,
        patientsWhiteList: response.patients,
        patientsWhiteListCount: response.count,
        patientsWhiteListIds: response.ids,
        searchString: '',
        page: 0,
        activeWarning: false
      });
      this.props.closeModal();
    })
    .catch(error => {
      console.log(error)
    });
  }

  showWarningBeforeSave = () => {
    this.setState({ ...this.state, activeWarning: true });
  }

  continueWhitoutSave = () => {
    this.setState({ ...this.state, activeWarning: false });
  }

  getPlaceholder = () => {
    switch (this.state.searchBy) {
      case 'name':
        return strings.search_by_name;
      case 'email':
        return strings.search_by_email;
      case 'insuranceCard':
        return strings.search_by_insurance_card;
      default:
    }
  }

  handleCloseModal = () => {
    this.setState({ ...this.state, searchString: '', searchBy: 'name' });
    this.props.closeModal();
  }

  handleDisableButton = () => {
    let isDisabled = true;

    if (this.state.searchString.trim() !== '') {
      this.state.searchPatientsList.forEach(patient => {
        if (patient.checked) {
          isDisabled = false;
        }
      });
    } else if (this.state.patientsWhiteList.length === 0) {
      isDisabled = true;
    } else {
      isDisabled = false;
    }

    return isDisabled;
  }

  render() {
    //console.log(this);
    
    return (
      <div id="patients-white-list-wrapper"  ref={this.setWrapperRef}>
        <div className="modal-header mb-4">
          <h5 className="modal-title">
              {svgs.users}
              {strings.customer_white_list_editor}
          </h5>
        </div>
        <div className="modal-body">

          <div className="row pl-3">
            <h3 className="qf-text-label">
              {strings.choose_search_criteria}
            </h3>
          </div>

          <div className="row">
            <div className="col-6 d-flex">
              {this.generateSearchCriteria('name')}
              {this.generateSearchCriteria('email')}
              {this.generateSearchCriteria('insuranceCard')}
            </div>
            <div className="formInput col-6 text-right">
              <i className="fa fa-search qf-search-patients-icon" />
              <input
                className="qf-search-patients-input pl-4"
                type="text"
                placeholder={this.getPlaceholder()}
                value={this.state.searchString}
                onChange={this.updateSearchString}
              />
            </div>
          </div>

          <div className="row pl-3 pr-3">
            <table className="qf-table qf-white-list-table mb-4 mt-4">

              {this.generateTableHead()}

              {this.state.searchString === '' ?
                this.generateTableBody('patientsWhiteList') :
                this.generateTableBody('searchPatientsList')}

            </table>
          </div>
          
          {this.state.searchString === '' ?
            this.generatePagination('patientsWhiteList') :
            this.generatePagination('searchPatientsList')}
          
          <div className="row">
            
            {this.state.activeWarning ? (
              <div className="col-12">
                <div className="row">
                  <div className="col-12 text-center p-2">
                    <h3>{strings.change_white_list_warning}</h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6 text-right">
                    <MainBtn
                      onclick={() => this.saveNewWhiteList(this.state.searchString === '' ? 'save' : 'add')}
                      title={strings.yes}
                      extraClasses="qf-blue-btn w-25"
                    />
                  </div>
                  <div className="col-6 text-left">
                    <MainBtn
                      onclick={this.continueWhitoutSave}
                      title={strings.no}
                      extraClasses="qf-blue-btn w-25"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-12">
                <div className="row pb-2">
                  <div className="col-6 text-right">
                    {this.state.loadingSpinner ? (
                      <div className="px-5 text-center p-3" />
                    ) : (
                      <CancelBtn
                        title={strings.cancel}
                        extraClasses="qf-gray-btn w-50"
                        onclick={this.handleCloseModal} />
                    )}
                  </div>
                  <div className="col-6 text-left">
                    {this.state.loadingSpinner ? (
                      <div className="col-11 white-bg px-5 text-center p-3">
                        <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#858585' }} />
                      </div>
                    ) : (
                      <MainBtn
                        onclick={this.showWarningBeforeSave}
                        title={this.state.searchString === '' ? strings.Save : strings.add}
                        disabledBtn={this.handleDisableButton()}
                        extraClasses="qf-blue-btn w-50"
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          
          </div>
        
        </div>
      
      </div>
    )
  }
}

export default PatientsWhiteListModal;


// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/components/PatientsWhiteListModal.js